import { createFileRoute, redirect, useRouter } from "@tanstack/react-router"
import { Button, GoogleSSO, LoginWrapper } from "toptaal-shared"
import { useAuthStore } from "@/stores/useAuthStore"
import { useLoginMethodStore } from "@/stores/useLoginMethodStore"

export const Route = createFileRoute("/login/google_sso")({
  component: RouteComponent,
  beforeLoad: async () => {
    const { getToken, getRefreshToken } = useAuthStore.getState()
    if (getToken() || getRefreshToken()) {
      throw redirect({ to: "/" })
    }

    const { method } = useLoginMethodStore.getState()
    if (method !== "google_sso") {
      throw redirect({ to: "/login" })
    }
  },
})

function RouteComponent() {
  const router = useRouter()
  const { clearMethod } = useLoginMethodStore()

  const handleChangeMethod = () => {
    clearMethod()
    router.navigate({ to: "/login" })
  }

  return (
    <LoginWrapper title="Inloggen">
      <a
        href={`${import.meta.env.VITE_API_URL}/auth/google`}
        className="flex w-full items-center justify-center rounded border border-light-grey px-4 py-2"
        rel="noopener noreferrer"
      >
        <GoogleSSO />
      </a>

      <Button
        type="button"
        variant="ghost"
        className="mx-auto mt-10"
        onClick={handleChangeMethod}
      >
        Inlogmethode wijzigen
      </Button>
    </LoginWrapper>
  )
}
